import AddFlightFile from '../ProtectPages/AdminPanel/FlightPanel/AddFlightFile';
import AddTafvigFile from '../ProtectPages/AdminPanel/AddTafvigFile';
import FlightPanel from '../ProtectPages/AdminPanel/FlightPanel/FlightPanel';
import PackagePanel from '../ProtectPages/AdminPanel/PackagePanel/PackagePanel';
import SearchBroker from '../ProtectPages/AdminPanel/SearchBroker';
import SearchPassenger from '../ProtectPages/AdminPanel/SearchPassenger';
import ChangePassword from '../ProtectPages/UserPanel/ChangePassword'
import DelayList from '../ProtectPages/AdminPanel/FlightPanel/DelayList';
import UpdatingMessage from '../PublicPages/UpdatingMessage';
import EditPackage from '../ProtectPages/AdminPanel/PackagePanel/EditPackage';
import PackageList from '../ProtectPages/AdminPanel/PackagePanel/PackageList';
import AddPackage from '../ProtectPages/AdminPanel/PackagePanel/AddPackage';
import EditAirLineSlA from '../ProtectPages/AdminPanel/DelayCompensation/EditAirLineSLA';
import AirLineSLAList from '../ProtectPages/AdminPanel/DelayCompensation/AirLineSLAList';
import FlightCompensation from '../ProtectPages/AdminPanel/DelayCompensation/FlightCompersation';

const PrivateRoutList = [
    {
        name: 'ChangePassword',
        path: 'User/changePassword',
        element: <ChangePassword />
    },
    {
        name: 'SearchPassenger',
        path: 'SearchPassenger',
        element: <SearchPassenger />
    },
     {
        name: 'SearchBroker',
        path: 'SearchBroker',
        element: <SearchBroker />
    } , 
         {
        name: 'FlightPanel',
        path: 'FlightPanel',
        element: <FlightPanel />
    }   
    , 
         {
        name: 'AddTafvigFile',
        path: 'AddTafvigFile',
        element: <AddTafvigFile />
    }   
    ,
             {
        name: 'AddFlightFile',
        path: 'AddFlightFile',
        element: <AddFlightFile />
    },
            {
        name: 'PackagePanel',
        path: 'PackagePanel',
        element: <PackagePanel />
    } ,

     {
        name: 'DelayList',
        path: 'DelayPanel/DelayList',
        element: <DelayList />
    } ,
    {
        name: 'AirLineSLAList',
        path: 'DelayPanel/AirLineSLAList',
        element: <AirLineSLAList />
    } ,
   {
        name: 'EditAirLineSLA',
        path: 'DelayPanel/EditAirLineSLA',
        element: <EditAirLineSlA />
    } ,   
   {
        name: 'EditFlightCompensation',
        path: 'DelayPanel/EditFlightCompensation/:id',
        element: <FlightCompensation />
    }, 
        {
        name: 'Package:CustomCreate',
        path: 'Package/Add',
        element: <AddPackage />
    } ,
          {
        name: 'Package:CustomCreate',
        path: 'Package/Edit/:id',
        element: <EditPackage />
    } ,
            {
        name: 'PackageList',
        path: 'PackageList',
        element: <PackageList />
    } ,
];
export default PrivateRoutList;

